import { render, staticRenderFns } from "./ColorsAndSizes.vue?vue&type=template&id=501843ce&"
import script from "./ColorsAndSizes.vue?vue&type=script&lang=js&"
export * from "./ColorsAndSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports